/* Dalen — Product gallery mobile dot pagination.
   Injects Dalen-style orange dot indicators beneath the mobile gallery
   slider. The dots:
     • Sit absolutely positioned at the bottom of the gallery's slider-component
     • Highlight the currently visible slide using Dawn's `slideChanged` event
     • Click a dot to scroll the gallery to that slide
   On desktop the gallery uses a vertical/grid layout (no slider), so the dots
   are hidden via @media (min-width: 750px) — the CSS rules only apply at
   max-width: 749px. */
(function () {
  function init() {
    document.querySelectorAll('product-info .product__media-wrapper').forEach(initOne);
  }

  function initOne(wrapper) {
    if (wrapper.dataset.dalenDotsReady) return;
    var sliderComp = wrapper.querySelector('slider-component');
    if (!sliderComp) return;
    var slider = sliderComp.querySelector('.product__media-list');
    var slides = sliderComp.querySelectorAll('.product__media-item');
    if (!slider || slides.length < 2) return;
    wrapper.dataset.dalenDotsReady = 'true';

    // Remove any existing thumbnail container (e.g. on section re-render)
    var existing = sliderComp.querySelector('.dalen-product-dots');
    if (existing) existing.remove();

    var container = document.createElement('div');
    container.className = 'dalen-product-dots';
    container.setAttribute('role', 'tablist');
    container.setAttribute('aria-label', 'Gallery slide navigation');

    var dots = [];
    for (var i = 0; i < slides.length; i++) {
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'dalen-product-dot' + (i === 0 ? ' is-active' : '');
      thumb.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      thumb.setAttribute('role', 'tab');
      thumb.dataset.index = String(i);

      // Pull a thumbnail image from this slide. For image slides this is
      // the inner <img>; for videos / model-viewer we fall back to the
      // deferred-media poster image so the thumbnail still has visuals.
      var slide = slides[i];
      var src   = '';
      var alt   = '';
      var img   = slide.querySelector('img');
      if (img) {
        src = img.currentSrc || img.src || (img.dataset && img.dataset.src) || '';
        alt = img.alt || '';
      }
      if (!src) {
        var poster = slide.querySelector('.deferred-media__poster img, [data-media-id] img');
        if (poster) { src = poster.src; alt = poster.alt || ''; }
      }
      if (src) {
        var thumbImg = document.createElement('img');
        thumbImg.src = src;
        thumbImg.alt = alt;
        thumbImg.loading = 'lazy';
        thumb.appendChild(thumbImg);
      }
      thumb.addEventListener('click', onDotClick);
      dots.push(thumb);
      container.appendChild(thumb);
    }
    sliderComp.appendChild(container);

    function onDotClick(e) {
      var idx = parseInt(e.currentTarget.dataset.index, 10);
      var target = slides[idx];
      if (!target) return;
      slider.scrollTo({
        left: target.offsetLeft - slides[0].offsetLeft,
        behavior: 'smooth'
      });
    }

    function syncDots() {
      if (!slides.length) return;
      var first = slides[0];
      var second = slides[1];
      var offset = second.offsetLeft - first.offsetLeft;
      if (!offset) return;
      var current = Math.round(slider.scrollLeft / offset);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    sliderComp.addEventListener('slideChanged', function (e) {
      var current = e.detail && e.detail.currentPage;
      if (current && dots.length) {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i + 1 === current); });
      } else {
        syncDots();
      }
    });
    slider.addEventListener('scroll', function () {
      requestAnimationFrame(syncDots);
    }, { passive: true });
    syncDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('product-info .product__media-wrapper')) {
      e.target.querySelectorAll('product-info .product__media-wrapper').forEach(function (w) {
        delete w.dataset.dalenDotsReady;
      });
      init();
    }
  });
})();
